import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { LocalStorageService } from '../../../../services/localstorage.service';
import { UtilitiesService } from '../../../../services/utilities.service';
import { MatchDetailLive } from '../../models/match-data.models';
import { GenericService } from '../../../../services/generic.services';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-dashboard-football',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dashboard-football.component.html',
  styleUrl: './dashboard-football.component.scss',
})
export class DashboardFootballComponent {
  urlImg = environment.urlIMG;
  urlIcon = environment.urlIcon;

  countMatch: any = '';
  interval: any;
  halfTimeCurrent: number = 0;
  private firstLoad = false;

  infoMatch: MatchDetailLive = {} as MatchDetailLive;

  today: any = '';

  sportSelected: string | null = null;

  @Input() set info(data: MatchDetailLive) {
    this.infoMatch = data;
  }

  @ViewChild('dashboardDetail') private targetElement!: ElementRef;

  public isFixed: boolean = false;

  constructor(
    private lsService: LocalStorageService,
    private ref: ChangeDetectorRef,
    private utilityServices: UtilitiesService,
    private genericServices: GenericService,
    private router: Router
  ) {
    this.today = this.genericServices.getCurrentDate();
    this.firstLoad = true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.firstLoad) {
      this.firstLoad = false;
      this.halfTimeCurrent = this.infoMatch.score.status.code;
      if (
        this.infoMatch &&
        (this.infoMatch.score.status.code == 2 ||
          this.infoMatch.score.status.code == 4 ||
          this.infoMatch.score.status.code == 5)
      ) {
        this.setTimeMatchLive();
      }
    } else {
      if (
        this.infoMatch.score.status.code != this.halfTimeCurrent &&
        (this.infoMatch.score.status.code == 2 ||
          this.infoMatch.score.status.code == 4 ||
          this.infoMatch.score.status.code == 5)
      ) {
        this.halfTimeCurrent = this.infoMatch.score.status.code;
        this.setTimeMatchLive();
      } else if (
        this.infoMatch.score.status.code != 2 &&
        this.infoMatch.score.status.code != 4 &&
        this.infoMatch.score.status.code != 5
      ) {
        this.clearCurrentTimeMatch();
      }
    }
  }

  private setTimeMatchLive() {
    if (this.infoMatch.score.matchTimeCurrent === '') {
      this.countMatch = '';
      return;
    }
    const self = this;
    clearInterval(this.interval);
    // this.interval = setInterval(function () {
    //   const timeNow: any = self.genericServices.guessTimezone();
    //   self.countMatch =
    //     self.infoMatch.score.status.code === 2
    //       ? timeNow
    //           .diff(self.infoMatch.score.timeInitMatch, 'minutes')
    //           .toString()
    //           .padStart(2, '0')
    //       : self.infoMatch.score.status.code === 4
    //       ? (timeNow.diff(self.infoMatch.score.timeInitMatch, 'minutes') + 45)
    //           .toString()
    //           .padStart(2, '0')
    //       : self.infoMatch.score.status.code === 5
    //       ? (timeNow.diff(self.infoMatch.score.timeInitMatch, 'minutes') + 90)
    //           .toString()
    //           .padStart(2, '0')
    //       : '';
    // }, 1000);
  }

  private clearCurrentTimeMatch() {
    this.countMatch = '';
    clearInterval(this.interval);
  }

  markTeamFavorite(team: any, type: string, info: any) {
    if (
      this.lsService.setFavoritesTeam({
        idTeam: team.id,
        national: team.national,
        logoCountry: team.country_logo,
        logo: team.logo,
        nameEs: team.name,
        nameEn: team.name,
        countryEs: '',
        countryEn: '',
        country: team.country,
      })
    ) {
      type === 'H'
        ? (info.favoriteHome = !info.favoriteHome)
        : (info.favoriteAway = !info.favoriteAway);
      this.ref.markForCheck();
    }
  }

  openTeam(team: any) {
    this.router.navigate([
      '/Futbol/' +
        this.utilityServices.getCountry(team.country) +
        '/team/' +
        team.name +
        '/' +
        team.id,
    ]);
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
  }
}
